import { render } from "./OnlyFooterDark.vue?vue&type=template&id=6d551bde&ts=true"
import script from "./OnlyFooterDark.vue?vue&type=script&lang=ts"
export * from "./OnlyFooterDark.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__